module.exports = __webpack_public_path__ + "static/media/iot.dc8ef888.png";